<div class="flag-selector">
  <orbit-context-menu [items]="items()" (itemClicked)="selectColor($any($event))" />
</div>
